import Http from "../../service/api";
import { judgeIsSplice } from "../../common/utils";

// -----------------------------  我的课程  -------------------------
/**
 * 查询课程集合 get query
 * @param {*} params 
 */
export async function getCourseList(params: any) {
  return Http.get(`/v1/curriculum/list${judgeIsSplice()}`, params);
}
/**
 * 新增课程 post formData
 * @param {*} params 
 */
export async function addCourse(params: any) {
  return Http.post(`/v1/curriculum/add${judgeIsSplice()}`, params);
}
/**
 * 绑定菜单和课程类型的关系 post body
 * @param {*} params 
 */
export async function addCourseRelation(params: any) {
  return Http.post(`/v1/ctype/setrelation${judgeIsSplice()}`, params);
}
/**
 * 修改课程状态 put formData
 * @param {*} params 
 */
export async function updateCourseStatus(params: any) {
  return Http.put(`/v1/curriculum/updatestatus${judgeIsSplice()}`, params);
}
/**
 * 上传文件 post formData
 * @param {*} params 
 */
export async function uploadFile(params: any) {
  return Http.post(`/v1/file/up${judgeIsSplice()}`, params, `formData`);
}
/**
 * 置顶课程排序 put formData
 * @param {*} params 
 */
export async function setCoursePlacetop(params: any) {
  return Http.put(`/v1/curriculum/placetop${judgeIsSplice()}`, params, 'formData');
}
// -----------------------------  分类管理  -------------------------
/**
 * 查询课程类型集合 get query
 * @param {*} params 
 */
export async function getCtypeList(params: any) {
  return Http.get(`/v1/ctype/list${judgeIsSplice()}`, params);
}
/**
 * 修改课程类型信息 put formData
 * @param {*} params 
 */
export async function updateCtypeInfo(params: any) {
  return Http.put(`/v1/ctype/update${judgeIsSplice()}`, params, `formData`);
}
/**
 * 修改课程类型状态 put formData
 * @param {*} params 
 */
export async function updateCtypeStatus(params: any) {
  return Http.put(`/v1/ctype/updatestatus${judgeIsSplice()}`, params, `formData`);
}
/**
 * 新增课件类型 post formData
 * @param {*} params 
 */
export async function addCtype(params: any) {
  return Http.post(`/v1/ctype/add${judgeIsSplice()}`, params, `formData`);
}
/**
 * 查询标签集合 get query
 * @param {*} params 
 */
export async function getTagList(params: any) {
  return Http.get(`/v1/tag/list${judgeIsSplice()}`, params);
}
/**
 * 新增标签 post formData
 * @param {*} params 
 */
export async function addTag(params: any) {
  return Http.post(`/v1/tag/add${judgeIsSplice()}`, params, `formData`);
}
/**
 * 修改标签信息 put formData
 * @param {*} params 
 */
export async function updateTagInfo(params: any) {
  return Http.put(`/v1/tag/update${judgeIsSplice()}`, params, `formData`);
}
/**
 * 修改标签状态-删除 put formData
 * @param {*} params 
 */
export async function updateTagStatus(params: any) {
  return Http.put(`/v1/tag/updatestatus${judgeIsSplice()}`, params, `formData`);
}
// -----------------------------  讲师管理  -------------------------
/**
 * 查询讲师集合 get query
 * @param {*} params 
 */
export async function getLecturerList(params: any) {
  return Http.get(`/v1/lecturer/list${judgeIsSplice()}`, params);
}
/**
 * 新增讲师 post formdata
 * @param {*} params 
 */
export async function addLecturer(params: any) {
  return Http.post(`/v1/lecturer/add${judgeIsSplice()}`, params, `formData`);
}
/**
 * 删除讲师 delete formData
 * @param {*} params 
 */
export async function deleteLecturer(params: any) {
  return Http.deletes(`/v1/lecturer/del${judgeIsSplice()}`, params);
}
/**
 * 更新讲师信息 put formData
 * @param {*} params 
 */
export async function updateLecturer(params: any) {
  return Http.put(`/v1/lecturer/update${judgeIsSplice()}`, params, `formData`);
}
// -----------------------------  课程详情  -------------------------
// -----------------------------  课程详情-课程信息  -------------------------
/**
 * 获取某个课程的信息 get query
 * @param {*} params 
 */
export async function getCourseInfo(params: any) {
  return Http.get(`/v1/curriculum/info${judgeIsSplice()}`, params);
}
/**
 * 修改课程信息 put body
 * @param {*} params 
 */
export async function updateCourseInfo(params: any) {
  return Http.put(`/v1/curriculum/update${judgeIsSplice()}`, params);
}
// -----------------------------  课程详情-课程章节  -------------------------
/**
 * 查询课件集合（管理员） get query
 * @param {*} params 
 */
export async function getCourseWareList(params: any) {
  return Http.get(`/v1/courseware/list${judgeIsSplice()}`, params);
}
/**
 * 新增课件 post formData
 * @param {*} params 
 */
export async function addCourseWare(params: any) {
  return Http.post(`/v1/courseware/add${judgeIsSplice()}`, params, `formData`);
}
/**
 * 修改课件信息 put formData
 * @param {*} params 
 */
export async function updateCourseWare(params: any) {
  return Http.put(`/v1/courseware/update${judgeIsSplice()}`, params, `formData`);
}
/**
 * 获取课件信息 get query
 * @param {*} params 
 */
export async function getCourseWareInfo(params: any) {
  return Http.get(`/v1/courseware/info${judgeIsSplice()}`, params);
}
/**
 * 文本新增或修改（批量） post body
 * @param {*} params 
 */
export async function addTextList(params: any) {
  return Http.post(`/v1/text/adduplist${judgeIsSplice()}`, params);
}
/**
 * 附件新增或修改(单个) post body
 * @param {*} params 
 */
export async function addAnnexesList(params: any) {
  return Http.post(`/v1/annexes/adduplist${judgeIsSplice()}`, params);
}
// 讲师
/**
 * 绑定课件和讲师关系 post body
 * @param {*} params 
 */
export async function setLecturerLation(params: any) {
  return Http.post(`/v1/courseware/setlecturerlation${judgeIsSplice()}`, params);
}
// 权限设置
/**
 * 人员组织结构 get query
 * @param {*} params 
 */
export async function getOrgInfo(params: any) {
  return Http.get(`/v1/org/depempinfo${judgeIsSplice()}`, params);
}
/**
 * 人员组织结构 get query
 * @param {*} params 
 */
export async function getDepInfo(params: any) {
  return Http.get(`/v1/org/depinfo${judgeIsSplice()}`, params);
}
/**
 * 绑定课程和部门的关系 post body
 * @param {*} params 
 */
export async function setDepRelation(params: any) {
  return Http.post(`/v1/curriculum/setdeprelation${judgeIsSplice()}`, params);
}
/**
 * 绑定课程和人员的关系 post body
 * @param {*} params 
 */
export async function setUserRelation(params: any) {
  return Http.post(`/v1/curriculum/setuserrelation${judgeIsSplice()}`, params);
}
/**
 * 获取课程与人员的关系 get query
 * @param {*} params 
 */
export async function getUserRelation(params: any) {
  return Http.get(`/v1/org/depempinfo${judgeIsSplice()}`, params);
}
// -----------------------------  课程详情-课程章节  -------------------------
/**
 * 新增章节 post FormData
 * @param {*} params 
 */
export async function addChapter(params: any) {
  return Http.post(`/v1/chapter/add${judgeIsSplice()}`, params, `formData`);
}
/**
 * 修改章节信息 put FormData
 * @param {*} params 
 */
export async function updateChapter(params: any) {
  return Http.put(`/v1/chapter/update${judgeIsSplice()}`, params, `formData`);
}
/**
 * 删除章节 delete FormData
 * @param {*} params 
 */
export async function deleteChapter(params: any) {
  return Http.deletes(`/v1/chapter/del${judgeIsSplice()}`, params);
}
/**
 * 删除课件 delete FormData
 * @param {*} params 
 */
export async function deleteCourseware(params: any) {
  return Http.deletes(`/v1/courseware/del${judgeIsSplice()}`, params);
}
/**
 * 章节移动 put FormData
 * @param {*} params 
 */
export async function moveChapter(params: any) {
  return Http.put(`/v1/chapter/move${judgeIsSplice()}`, params, `formData`);
}
/**
 * 课件移动 put FormData
 * @param {*} params 
 */
export async function moveCourseware(params: any) {
  return Http.put(`/v1/courseware/move${judgeIsSplice()}`, params, `formData`);
}
// 文件处理
/**
 * 文件上传前签名处理 get query
 * @param {*} params 
 */
export async function getUploadSign(params: any) {
  return Http.get(`/v1/file/upbeforesign${judgeIsSplice()}`, params);
}
/**
 * 获取文件存储对象的链接 get query
 * @param {*} params 
 */
export async function getFileUrl(params: any) {
  return Http.get(`/v1/file/getfilurl${judgeIsSplice()}`, params);
}
// -----------------------------  课程中心-轮播管理  -------------------------
/**
 * 弹窗获取菜单下的类型和标签 get query
 * @param {*} params 
 */
export async function getAllTypes(params: any) {
  return Http.get(`/v1/index/typetags${judgeIsSplice()}`, params);
}
/**
 * 查询轮播图集合 get query
 * @param {*} params 
 */
export async function getBannerList(params: any) {
  return Http.get(`/v1/slideshow/list${judgeIsSplice()}`, params);
}
/**
 * 更新轮播图信息 put body
 * @param {*} params 
 */
export async function updateBanner(params: any) {
  return Http.put(`/v1/slideshow/update${judgeIsSplice()}`, params);
}
/**
 * 新增轮播图 post body
 * @param {*} params 
 */
export async function addBanner(params: any) {
  return Http.post(`/v1/slideshow/add${judgeIsSplice()}`, params);
}
/**
 * 删除轮播图 delete query
 * @param {*} params 
 */
export async function delBanner(params: any) {
  return Http.deletes(`/v1/slideshow/del${judgeIsSplice()}`, params);
}
// *******************录入考试*******************
/**
 * 设置考试信息 post formData
 * @param {*} params 
 */
export async function setExam(params: any) {
  return Http.post(`/v1/exam/set${judgeIsSplice()}`, params, 'formData');
}
// ------------------------------ 课程统计 ------------------------------
/**
 * 一天内所有课程的点击人数 get query
 * @param {*} params 
 */
export async function censusCurriculumDayview(params: any) {
  return Http.get(`/v1/count/curriculum/dayview${judgeIsSplice()}`, params);
}
/**
 * 一段时间内每天某一课程的点击总人数（曲线或柱状）,区间支持最大60天 get query
 * @param {*} params 
 */
export async function censusCurriculumDateOne(params: any) {
  return Http.get(`/v1/count/curriculum/dateone${judgeIsSplice()}`, params);
}
/**
 * 一段时间内每天点击的总人数（曲线或柱状）,区间支持最大60天 get query
 * @param {*} params 
 */
export async function censusCurriculumDateTotal(params: any) {
  return Http.get(`/v1/count/curriculum/datetotal${judgeIsSplice()}`, params);
}
/**
 * 获取所有类型的点击数（曲线或柱状），可分页 get query
 * @param {*} params 
 */
export async function getTypeView(params: any) {
  return Http.get(`/v1/count/type/view${judgeIsSplice()}`, params);
}
/**
 * 某课程时间段点击数 get query
 * @param {*} params 
 */
export async function countCurriculumSee(params: any) {
  return Http.get(`/v1/count/curriculumsee${judgeIsSplice()}`, params);
}
// ------------------------------ 表格 ------------------------------
// 以下是课程的
/**
 * 根据课程ID和人员ID查询对应的课件学习进度，可分页（待数据确认） get query
 * @param {*} params 
 */
export async function getStudentCourseware(params: any) {
  return Http.get(`/v1/table/courseware/studyinfo${judgeIsSplice()}`, params);
}
/**
 * 导出课程和课件数据 get query
 * @param {*} params 
 */
export async function exportCurriculum(params: any) {
  return Http.get(`/v1/table/curriculum/export${judgeIsSplice()}`, params);
}
/**
 * 根据课程获取人员学习情况，可分页 get query
 * @param {*} params 
 */
export async function getStudentData(params: any) {
  return Http.get(`/v1/table/curriculum/studyinfo${judgeIsSplice()}`, params);
}
// 以下是讲师的
/**
 * 获取讲师所讲课程的总的得分（所讲课件的总分），可分页（待数据确认） get query
 * @param {*} params 
 */
export async function getLecturerTotal(params: any) {
  return Http.get(`/v1/table/lecturer/total${judgeIsSplice()}`, params);
}
/**
 * 获取讲师所讲每个课程的总得分（所讲课件的总分），可分页（待数据确认） get query
 * @param {*} params 
 */
export async function getLecturerCurriculums(params: any) {
  return Http.get(`/v1/table/lecturer/curriculumscore${judgeIsSplice()}`, params);
}
/**
 * 获取讲师的某一课程的课件信息（所讲课件的总分），可分页（待数据确认） get query
 * @param {*} params 
 */
export async function getLecturerCourseware(params: any) {
  return Http.get(`/v1/table/lecturer/coursewarescore${judgeIsSplice()}`, params);
}
/**
 * 导出讲师相关数据 get query
 * @param {*} params 
 */
export async function exportLecturer(params: any) {
  return Http.get(`/v1/table/lecturer/export${judgeIsSplice()}`, params);
}
// 以下是部门的
/**
 * 获取部门学习完成百分比（待数据确认） get query
 * @param {*} params 
 */
export async function getDepStudyinfo(params: any) {
  return Http.get(`/v1/table/dep/studyinfo${judgeIsSplice()}`, params);
}
